import { render } from "./ConversationsList.vue?vue&type=template&id=654dcf60"
import script from "./ConversationsList.vue?vue&type=script&lang=js"
export * from "./ConversationsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__